import { render } from "./AssignBa.vue?vue&type=template&id=5fe49ae6"
import script from "./AssignBa.vue?vue&type=script&lang=js"
export * from "./AssignBa.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__